import { type FC, type MouseEvent } from 'react';
import { type SbSharedRefineMenuFramingInput_itemSearch$key } from './__generated__/SbSharedRefineMenuFramingInput_itemSearch.graphql.ts';

import { graphql, useFragment } from 'react-relay';
import { useIntl, type MessageDescriptor } from 'dibs-react-intl';
import { useDispatch } from 'react-redux';
import { updateUriRef } from '../../../actions/filterActions.ts';
import { getFilterValues } from '../sbSharedRefineMenuHelpers.ts';

import { SbSharedRefineMenuInputCheckbox } from '../../SbSharedRefineMenu/SbSharedRefineMenuInput/SbSharedRefineMenuInputCheckbox.jsx';
import { areFiltersApplied } from '../../helpers/appliedFilters/areFiltersApplied.ts';

type Props = {
    itemSearch: SbSharedRefineMenuFramingInput_itemSearch$key;
    filterName: string;
    title: MessageDescriptor;
};

export const SbSharedRefineMenuFramingInput: FC<Props> = props => {
    const { itemSearch: itemSearchRef, filterName, title } = props;
    const intl = useIntl();
    const dispatch = useDispatch();

    const itemSearch = useFragment(
        graphql`
            fragment SbSharedRefineMenuFramingInput_itemSearch on ItemSearchQueryConnection {
                ...areFiltersApplied_itemSearch
                filters {
                    name
                    values {
                        linkReference
                        linkable
                        urlLabel
                        count
                    }
                }
                searchResultData {
                    vectorResultCount
                }
            }
        `,
        itemSearchRef
    );

    const filters = itemSearch?.filters || [];
    const hasVectorSearchResults = !!itemSearch?.searchResultData?.vectorResultCount;
    const framingFilterValues = getFilterValues(filters, filterName);
    const isFilterApplied = areFiltersApplied(itemSearch, [filterName]);

    return (
        <>
            {framingFilterValues.map(filter => (
                <SbSharedRefineMenuInputCheckbox
                    key={filter.urlLabel}
                    value={filter.urlLabel || ''}
                    linkReference={filter.linkReference}
                    linkable={filter.linkable}
                    checked={isFilterApplied}
                    onChange={(checked: boolean, event: MouseEvent<HTMLElement>) => {
                        dispatch(
                            updateUriRef({
                                filterName,
                                filterValue: filter,
                                isDeselected: !checked,
                                uriRef: null,
                                event,
                                ga: undefined,
                            })
                        );
                    }}
                    text={intl.formatMessage(title)}
                    count={filter?.count}
                    hasVectorSearchResults={hasVectorSearchResults}
                />
            ))}
        </>
    );
};
